export {
	signIn,
	signInByEmailOrPhone,
	signUpWithEmail,
	activateEmail,
	passwordResetPrepare,
	passwordResetValidate,
	passwordResetPerform } from './authService'
